import { Injectable } from '@angular/core';
import { ApplicationFormService } from '../application-form/application-form.service';
import { DataService } from '@app/core/services/data.service';
import { ApplicationFormDataService } from '../application-form/application-form-data.service';
import { regEx } from '@app/core/constants/regEx';
import { validationMsgs } from '@app/core/constants/validationMsgs';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { AbstractControl } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class ResidentsService {

    referenceTypes = this.afs.getRefDataModel();
    subscription = this.afs.subscribeRefDataModel((data: any) => {
        this.referenceTypes = data
    });

    constructor(
        private afs: ApplicationFormService,
        private dataService: DataService,
        private afds: ApplicationFormDataService
    ) {
    }

    yesNoMap = [
        {
            "value": false,
            "name": "No"
        },
        {
            "value": true,
            "name": "Yes"
        }
    ];

    fetchForm(): any {
        return [
            {
                wrappers: [ 'connectSection' ],
                props: { htmlClass: 'section' },
                fieldGroup: [
                    {
                        wrappers: [ 'section' ],
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'row' },
                                fieldGroup: [
                                    {
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'col-sm-12' },
                                        fieldGroup: [
                                            {
                                                key: "isAdditionalResidents",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.yesNoMap,
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Will there be any other residents living at the property besides the applicant(s)?"
                                                },
                                            },
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                expressions: {
                    hide: "!model.isAdditionalResidents"
                },
                wrappers: [ 'connectSection' ],
                props: { htmlClass: 'section' },
                fieldGroup: [
                    {
                        wrappers: [ 'section' ],
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'row' },
                                fieldGroup: [
                                    {
                                        key: 'additionalResidents',
                                        defaultValue: [ null ],
                                        type: 'array',
                                        props: {
                                            add: 'Add an Additional Resident',
                                            itemTitle: 'Additional Resident',
                                            style: {
                                                add: 'btn-success'
                                            },
                                            htmlClass: 'col-sm-12',
                                        },
                                        fieldArray: {
                                            fieldGroup: [
                                                {
                                                    wrappers: [ 'section' ],
                                                    props: { htmlClass: 'row' },
                                                    fieldGroup: [
                                                        {
                                                            wrappers: [ 'section' ],
                                                            props: { htmlClass: 'col-sm-6' },
                                                            fieldGroup: [
                                                                {
                                                                    key: 'title',
                                                                    type: 'select',
                                                                    props: {
                                                                        title: 'Title',
                                                                        required: true,
                                                                        options: this.dataService
                                                                            .getReferenceDataByName(this.referenceTypes,
                                                                                "cn_titletype")
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            wrappers: [ 'section' ],
                                                            props: { htmlClass: 'col-sm-6' },
                                                            fieldGroup: [
                                                                {
                                                                    key: 'firstName',
                                                                    type: 'input',
                                                                    props: {
                                                                        title: 'First Name',
                                                                        required: true,
                                                                        minLength: 0,
                                                                        maxLength: 35,
                                                                        pattern: regEx.namePattern,
                                                                    },
                                                                    validation: {
                                                                        messages: {
                                                                            pattern: validationMsgs.alphaOnly
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    wrappers: [ 'section' ],
                                                    props: { htmlClass: 'row' },
                                                    fieldGroup: [
                                                        {
                                                            wrappers: [ 'section' ],
                                                            props: { htmlClass: 'col-sm-6' },
                                                            fieldGroup: [
                                                                {
                                                                    key: 'middleName',
                                                                    type: 'input',
                                                                    props: {
                                                                        title: 'Middle Name',
                                                                        maxLength: 50,
                                                                        pattern: regEx.namePattern,
                                                                    },
                                                                    validation: {
                                                                        messages: {
                                                                            pattern: validationMsgs.alphaOnly
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            wrappers: [ 'section' ],
                                                            props: { htmlClass: 'col-sm-6' },
                                                            fieldGroup: [
                                                                {
                                                                    key: 'lastName',
                                                                    type: 'input',
                                                                    props: {
                                                                        title: 'Last Name',
                                                                        required: true,
                                                                        maxLength: 35,
                                                                        pattern: regEx.namePattern,
                                                                    },
                                                                    validation: {
                                                                        messages: {
                                                                            pattern: validationMsgs.alphaOnly
                                                                        }
                                                                    }
                                                                }
                                                            ]
                                                        }

                                                    ]
                                                },
                                                {
                                                    wrappers: [ 'section' ],
                                                    props: { htmlClass: 'row' },
                                                    fieldGroup: [
                                                        {
                                                            wrappers: [ 'section' ],
                                                            props: { htmlClass: 'col-sm-6' },
                                                            fieldGroup: [
                                                                {
                                                                    key: 'birthDate',
                                                                    type: 'datepicker',
                                                                    props: {
                                                                        title: 'Date of Birth',
                                                                        required: true,
                                                                        supportingText: "dd/mm/yyyy",
                                                                        minAge: 0,
                                                                        maxAge: 120,
                                                                    },
                                                                },
                                                            ]
                                                        },
                                                        {
                                                            wrappers: [ 'section' ],
                                                            props: { htmlClass: 'col-sm-6' },
                                                            fieldGroup: [
                                                                {
                                                                    key: "gender",
                                                                    type: "radiobuttons",
                                                                    props: {
                                                                        options: this.dataService.getReferenceDataByName(this.referenceTypes, "cn_gendertype"),
                                                                        labelHtmlClass: "control-label",
                                                                        activeClass: "active",
                                                                        required: true,
                                                                        title: "Gender"
                                                                    },
                                                                },
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    wrappers: [ 'section' ],
                                                    props: { htmlClass: 'row' },
                                                    fieldGroup: [
                                                        {
                                                            wrappers: [ 'section' ],
                                                            props: { htmlClass: 'col-sm-6' },
                                                            fieldGroup: [
                                                                {
                                                                    key: 'employmentSituationTypeId',
                                                                    type: 'select',
                                                                    props: {
                                                                        title: 'Employment Status',
                                                                        required: true,
                                                                        options: this.dataService.getReferenceDataByName(this.referenceTypes, "cn_employmentsituationtype")
                                                                    }
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            wrappers: [ 'section' ],
                                                            props: { htmlClass: 'col-sm-6' },
                                                            fieldGroup: [
                                                                {
                                                                    key: 'relationshipTypeId',
                                                                    type: 'select',
                                                                    props: {
                                                                        title: 'Relationship to Lead Applicant',
                                                                        required: true,
                                                                        options: this.dataService.getReferenceDataByName(this.referenceTypes, "cn_relationshiptype")
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                wrappers: [ 'connectSection' ],
                props: { htmlClass: 'section' },
                fieldGroup: [
                    {
                        wrappers: [ 'section' ],
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'row' },
                                fieldGroup: [
                                    {
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'col-sm-12' },
                                        fieldGroup: [
                                            {
                                                key: "isPets",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.yesNoMap,
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Will you have any pets in this property?"
                                                },
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                expressions: {
                                    hide: "!model.isPets"
                                },
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'row' },
                                fieldGroup: [
                                    {
                                        // "retain" keeps the value of the property event though the field is no longer in the form or being vaidated before submit.
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'col-xs-12 col-sm-4 col-md-2' },
                                        fieldGroup: [
                                            {
                                                key: 'isPetCat',
                                                type: 'checkbox',
                                                props: {
                                                    title: 'Cat(s)',
                                                    change: (f: FormlyFieldConfig) => {
                                                        f.form?.get('isPetDog')?.updateValueAndValidity();
                                                        f.form?.get('isPetOther')?.updateValueAndValidity();
                                                    },
                                                },
                                                validators: {
                                                    petsCheck: {
                                                        expression: (c: AbstractControl, f: FormlyFieldConfig) => {
                                                            if (!f.model.isPetDog && !f.model.isPetOther) {
                                                                if (c.value === true) {
                                                                    return true;
                                                                }
                                                                else {
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                return true;
                                                            }
                                                        },

                                                        //error-summary
                                                        title: 'Cat(s)',
                                                        msg: 'At least one pet must be selected'
                                                    }
                                                },
                                                validation: {
                                                    messages: {
                                                        petsCheck: 'At least one pet must be selected'
                                                    }
                                                }
                                            },


                                        ]
                                    },
                                    {
                                        // "retain" keeps the value of the property event though the field is no longer in the form or being vaidated before submit.
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'col-xs-12 col-sm-4 col-md-2' },
                                        fieldGroup: [
                                            {

                                                key: 'isPetDog',
                                                type: 'checkbox',
                                                props: {
                                                    title: 'Dog(s)',
                                                    change: (f: FormlyFieldConfig) => {
                                                        f.form?.get('isPetCat')?.updateValueAndValidity();
                                                        f.form?.get('isPetOther')?.updateValueAndValidity();
                                                    },
                                                },
                                                validators: {
                                                    petsCheck: {
                                                        expression: (c: AbstractControl, f: FormlyFieldConfig) => {
                                                            if (!f.model.isPetCat && !f.model.isPetOther) {
                                                                if (c.value === true) {
                                                                    return true;
                                                                }
                                                                else {
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                return true;
                                                            }
                                                        },
                                                        title: 'Dog(s)',
                                                        msg: 'At least one pet must be selected'
                                                    }
                                                },
                                                validation: {
                                                    messages: {
                                                        petsCheck: 'At least one pet must be selected'
                                                    }
                                                }

                                            },

                                        ]
                                    },
                                    {
                                        // "retain" keeps the value of the property event though the field is no longer in the form or being vaidated before submit.
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'col-xs-12 col-sm-4 col-md-2' },
                                        fieldGroup: [
                                            {

                                                key: 'isPetOther',
                                                type: 'checkbox',
                                                props: {
                                                    title: 'Other(s)',
                                                    change: (f: FormlyFieldConfig) => {
                                                        f.form?.get('isPetCat')?.updateValueAndValidity();
                                                        f.form?.get('isPetDog')?.updateValueAndValidity();
                                                    },
                                                },
                                                validators: {
                                                    petsCheck: {
                                                        expression: (c: AbstractControl, f: FormlyFieldConfig) => {
                                                            if (!f.model.isPetCat && !f.model.isPetDog) {
                                                                if (c.value === true) {
                                                                    return true;
                                                                }
                                                                else {
                                                                    return false;
                                                                }
                                                            }
                                                            else {
                                                                return true;
                                                            }
                                                        },
                                                        title: 'Other(s)',
                                                        msg: 'At least one pet must be selected'
                                                    }
                                                },
                                                validation: {
                                                    messages: {
                                                        petsCheck: 'At least one pet must be selected'
                                                    }
                                                }
                                            },
                                        ]
                                    },
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                wrappers: [ 'connectSection' ],
                props: { htmlClass: 'section' },
                fieldGroup: [
                    {
                        wrappers: [ 'section' ],
                        fieldGroup: [
                            {
                                wrappers: [ 'section' ],
                                props: { htmlClass: 'row' },
                                fieldGroup: [
                                    {
                                        wrappers: [ 'section' ],
                                        props: { htmlClass: 'col-sm-12' },
                                        fieldGroup: [
                                            {
                                                key: "isPregnant",
                                                type: "radiobuttons",
                                                props: {
                                                    options: this.dataService.getReferenceDataByName(this.referenceTypes, "cn_pregnancytype"),
                                                    labelHtmlClass: "control-label",
                                                    activeClass: "active",
                                                    required: true,
                                                    title: "Is anyone who will be living with you pregnant?"
                                                },
                                            },
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
}
